import React from "react";
import { Chart as ChartJS, ArcElement, Tooltip, Legend, CategoryScale, LinearScale, BarElement, Title } from 'chart.js/auto';
import { Bar } from 'react-chartjs-2';
import { CommonUtilities } from "../../commonUtils";
ChartJS.register(ArcElement, Tooltip, Legend);

export default function StackedBarChart(chartPassedData: any) {

    console.log(chartPassedData)
    const options = {
        ...chartPassedData?.chartPassedData?.options,
        type: 'bar',
        responsive: true,
        plugins: {
            ...chartPassedData?.chartPassedData?.plugins,
        },

    };
 

    return (
        <div className="ws-12">
            {chartPassedData?.chartPassedData?.data?.labels.length > 0 && <div style={CommonUtilities.parseStyleString(chartPassedData?.style)}>
                <Bar options={chartPassedData?.chartPassedData.options} data={chartPassedData?.chartPassedData.data} />
            </div>}

            {chartPassedData?.chartPassedData?.data?.labels.length == 0 && <span className="text-center text-bold ws-12 mtl grey"> Not actioned. </span>}

        </div>

    )
}